var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flow-common-approval-form"},[(_vm.formContainer)?[_c(_vm.formContainer,_vm._b({tag:"component"},'component',_vm.formInfo,false))]:[_c('div',{staticClass:"empty-hint"},[_vm._v("暂无表单数据")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }